import { getValidatedXundUrl } from './utils'

export const getXundUrls = (params: { webappBaseUrl?: string | null; authBaseUrl?: string | null }) => {
  const webappBaseUrl = getValidatedXundUrl(params.webappBaseUrl, 'https://frame.webapp.class2.xund.solutions')
  const authBaseUrl = getValidatedXundUrl(params.authBaseUrl, 'https://login.xund.solutions/api')
  return { webappBaseUrl, authBaseUrl }
}
